import styled, { css } from 'styled-components';

import media from '~/utils/media';
import checkboxStd from '~/components/styled/checkbox';

export const Wrap = styled.div`

`;

export const TopWrap = styled.div`

`;

export const AgreeWrap = styled.div`
  height: auto;
  padding: 4% 6%;
  background-color: #fff;
  position: relative;

  > div.youtube {
    max-width: 650px;
    text-align: center;
    /* position: absolute;
    top: 51.5%; */

    > div {
      height: 0;
      padding-top: 56.25%;
      position: relative;
    }

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    p {
      margin-top: 4%;
      text-align: center;

      ${media.pcLarge`
        font-size: 20px;
      `}

      ${media.tabletLarge`
        font-size: 20px;
      `}

      ${media.tabletSmall`
        font-size: 20px;
      `}

      ${media.mobileLarge`
        font-size: 14px;
      `}

      ${media.mobileMid`
        font-size: 12px;
      `}

      ${media.mobileSmall`
        font-size: 12px;
      `}

      > span {
        color: #306cf8;
      }

      font-weight: 700;
      color: #606060;
      letter-spacing: -0.5px;
    }

    & + div {
      margin-top: 4%;
    }
  }

  /* > div.youtube {
    width: 100%;
    height: 150%;

    iframe {
      width: 100%;
      height: 100%;
    }

    
  } */
`;

export const LabelWrap = styled.div`
  padding-left: 3%;

  & + & {
    margin-top: 4%;
  }
`;

export const Label = styled.label`
  display: inline-flex;
  align-items: center;
  width: 100%;
  
  ${media.pcLarge`
    font-size: 20px;
  `}

  ${media.tabletLarge`
    font-size: 20px;
  `}

  ${media.tabletSmall`
    font-size: 20px;
  `}

  ${media.mobileLarge`
    font-size: 14px;
  `}

  ${media.mobileMid`
    font-size: 14px;
  `}

  ${media.mobileSmall`
    font-size: 14px;
  `}

  font-weight: 700;
  color: #4a4b4c;
  letter-spacing: -1px;

  > svg {
    margin-left: 2%;

    ${({ isCheck }) => isCheck ? css`
      transform: rotate(-180deg);
      transition: transform 150ms ease;
    ` : css`
      transform: rotate(0deg);
      transition: transform 150ms ease;
    `}

    ${media.mobileSmall`
      width: 32px;
      height: 32px;
    `}

    ${media.pcLarge`
      width: 32px;
      height: 32px;
    `}

    ${media.tabletLarge`
      width: 32px;
      height: 32px;
    `}

    ${media.tabletSmall`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileLarge`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileMid`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileSmall`
      width: 20px;
      height: 20px;
    `}
  }
`;

export const Checkbox = styled.input`
  ${checkboxStd};

  ${media.mobileSmall`
    width: 24px;
    height: 24px;
  `}

  ${media.pcLarge`
    width: 24px;
    height: 24px;
  `}

  ${media.tabletLarge`
    width: 24px;
    height: 24px;
  `}

  ${media.tabletSmall`
    width: 24px;
    height: 24px;
  `}

  ${media.mobileLarge`
    width: 20px;
    height: 20px;
  `}

  ${media.mobileMid`
    width: 20px;
    height: 20px;
  `}

  ${media.mobileSmall`
    width: 20px;
    height: 20px;
  `}

  margin-right: 2%;
`;

export const QuestionWrap = styled.div`
  position: relative;

  > img {
    cursor: pointer;
    position: absolute;

    &.q1-1 {
      width: 44%;
      top: 13%;
      left: 8%;
    }
    
    &.q1-2 {
      width: 44%;
      top: 13%;
      left: 52%;
    }

    &.q2-1 {
      width: 22%;
      top: 28%;
      left: 8%;
    }

    &.q2-2 {
      width: 22%;
      top: 28%;
      left: 30%;
    }

    &.q2-3 {
      width: 22%;
      top: 28%;
      left: 52%;
    }

    &.q2-4 {
      width: 22%;
      top: 28%;
      left: 74%;
    }

    &.q3-1 {
      width: 44%;
      top: 43%;
      left: 8%;
    }

    &.q3-2 {
      width: 44%;
      top: 43%;
      left: 52%;
    }

    &.submit {
      width: 44%;
      top: 86.5%;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  > .text-wrap {
    width: 86%;
    height: 12%;
    padding: 2% 2% 6%;
    background-color: #f5f4f6;
    position: absolute;
    top: 66%;
    left: 50%;
    transform: translateX(-50%);

    > textarea {
      width: 96%;
      height: 100%;
      background-color: #f5f4f6;
      border: 0;
      resize: none;
    }

    > p {
      ${media.pcLarge`
        font-size: 14px;
      `}

      ${media.tabletLarge`
        font-size: 14px;
      `}

      ${media.tabletSmall`
        font-size: 14px;
      `}

      ${media.mobileLarge`
        font-size: 12px;
      `}

      ${media.mobileMid`
        font-size: 12px;
      `}

      ${media.mobileSmall`
        font-size: 12px;
      `}
      color: #cacacb;
      position: absolute;
      bottom: 6%;
      right: 2%;
    }
  }
`;
